import { customAxios, FDV_URL, USERNAME, IDUSUARIO, TOKEN } from "../constants";
import { evalAction, serverError } from "../utils/actionError";


export function fetchEntregaDetalle(numPedidoVeh){

    const config = {

        params: {
            numPedidoVeh: numPedidoVeh
        },

        headers: {
            codUsuario: USERNAME,
            idUsuario: IDUSUARIO,
            token: TOKEN,
        }
    };

    const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-ventas/detalleEntregaPedido`,config)
    .then(({data}) => evalAction(data, 'listar'))
    .catch(error => serverError(error, 'listar'))

    return {
        type: 'FETCH_ENTREGA_PEDIDO_DETALLE',
        payload: request,
    }
}

export function fetchEntregaDetalleAdicional(codPlanEntrVehi) {

    const config = {

        params: {
            codigo: codPlanEntrVehi
        },

        headers: {
            codUsuario: USERNAME,
            idUsuario: IDUSUARIO,
            token: TOKEN,
        }
    };

    const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-ventas/planificaciones/${codPlanEntrVehi}/personal`, config)
        .then(({data}) => evalAction(data, 'listar'))
        .catch(error => serverError(error, 'listar'))

    return {
        type: 'FETCH_ENTREGA_PEDIDO_DETALLE_ADICIONAL',
        payload: request,
    }
}


// WEBPACK FOOTER //
// ./src/actions/EntregaAction.js